import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IProfessionalSituationResource } from "../../professional-situations";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { IBrief } from "../types/IBrief";

export type IBriefCreateMutationParameters = Pick<
    IBrief,
    | "title"
    | "description"
    | "context"
    | "pedagogicModalities"
    | "performanceCriteria"
    | "evaluationModalities"
    | "status"
    | "isReflectiveAnalysisEnabled"
    | "estimatedDuration"
> & {
    // Optional, as a brief is now created through its deliverables list.
    expectedWork?: IBrief["expectedWork"];
    deliverables?: { label: string }[];
    image?: string;
    skillLevels: string[];
    tags: string[];
    media: string[];
    professionalSituation?: RelationalValue<IProfessionalSituationResource>;
    uuid?: string;
};

export type IBriefCreateMutationResult = IBrief;

export const briefCreateMutation: IApiMutationFunction<IBriefCreateMutationParameters> = ({
    professionalSituation,
    ...data
}) => {
    return {
        method: "POST",
        url: "/briefs",
        data: {
            ...data,
            uuid: data.uuid ?? uuid(),
            professionalSituation: mapRelationalValueAsIRI(EntityTypes.PROFESSIONAL_SITUATION, professionalSituation),
        },
    };
};

export const useBriefCreateMutation = createApiMutationHook<IBriefCreateMutationParameters, IBriefCreateMutationResult>(
    briefCreateMutation,
);
